import { render, staticRenderFns } from "./ProviderApplyLayer.vue?vue&type=template&id=07989e64&scoped=true&"
import script from "./ProviderApplyLayer.vue?vue&type=script&lang=js&"
export * from "./ProviderApplyLayer.vue?vue&type=script&lang=js&"
import style0 from "./ProviderApplyLayer.vue?vue&type=style&index=0&id=07989e64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07989e64",
  null
  
)

export default component.exports